import {BaseComponentLocator} from './base.component-locator';


export class AthleteLocatorComponent extends BaseComponentLocator {

  public constructor(protected _id: number = null) {
    super();
  };

  public toString(): string {
    let str: string;
    if (this._id === null) {
      str = 'AthIdNotSet';
    }
    else {
      str = this._id + '';
    }
    return str;
  }
  
  /**
   * disciplineId setter/getter.
   */
  public set id(id: number) {
    this._id = id;
  }

  public get id(): number {
    return this._id;
  }
}

